exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*ant design主题色*/\n/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n/*存放基色*/\n._MutiMonitorLeftBar_ {\n  height: calc(100vh - 64px);\n}\n._MutiMonitorLeftBar_ .ant-menu-item-selected {\n  background-color: #e6f7ff !important;\n}\n._MutiMonitorLeftBar_ .ant-menu {\n  background-color: #373737;\n}\n", ""]);

// exports
